import * as React from "react";
import classnames from "classnames";
import { format } from "d3-format"
import { timeFormat } from "d3-time-format"

import { Key } from "../../../models";
import { TooltipInfo, SequenceState, IDataSequence } from "../../Data";
import { Polyglot } from "../../../polyglot";

const styles = require('./Tooltip.local.css');

interface Props
{
    polyglot: Polyglot;
    
    info: TooltipInfo;
    left: number;
    top: number;
    elemRef: (div: HTMLDivElement) => void;
    onToggle: (key: Key) => void;
    
    highlight: (key: Key) => void;
    normolize: () => void;

    className?: string;
};

// Tooltip component for timeseries chart
// We use Polyglot to show hint which describes how to freeze tooltip in order to interact with it
// Tooltip is a grid where each row corresponds to displayed sequence of data. The structure of the table is as follows:
// [color markder with title of the sequence] --- [value] --- [show/hide checkbox]
export class Tooltip extends React.Component<Props, any>
{
    render()
    {
        const tFormat = timeFormat('%Y-%m-%d %H:%M:%S');
        const vFormat = format(".3r");
        const { info, left, top, elemRef } = this.props;

        return info ? (
            <div className={classnames(styles.TooltipContainer, this.props.className)} style={{ left, top }} ref={elemRef}>
                <table>
                    <thead>
                        <tr>
                            <th colSpan={3}>{tFormat(info.x)}</th>
                        </tr>
                    </thead>

                    <tbody>
                    { info.items.map((item, idx) => (
                            <tr key={idx} onMouseEnter={e => this.tryHighlight(item.sequence)} onMouseLeave={e => this.props.normolize()}>
                                <td>
                                    <span className={item.sequence.dotType === 'square' ? styles.SquareIcon : styles.CircleIcon} style={{backgroundColor: item.sequence.color}}/>
                                    <span>{item.sequence.title}</span>
                                </td>
                                <td>{vFormat(item.value)}</td>
                                <td><input type="checkbox" checked={item.sequence.state !== SequenceState.Hidden} onChange={e => this.props.onToggle(item.sequence.id)} /></td>
                            </tr>
                        ))
                    }
                    { info.items.length > 1 && (
                        <tr>
                            <td className={styles.Hint} colSpan={3}>{this.props.polyglot.t('sensors_data.tooltip_hint')}</td>
                        </tr>)
                    }
                    </tbody>
                </table>
            </div>
        ) : null;
    }

    // this method marks sequence as highlighted
    private tryHighlight = (seq: IDataSequence) => {
        if(seq.state === SequenceState.Hidden)
            return;

        this.props.highlight(seq.id);
    }
}


// WEBPACK FOOTER //
// ./src/charts/TimeSeries/Tooltip/Tooltip.tsx